module.exports = __webpack_public_path__ + "static/img_21-1669cce6f651e5777eaadaeb404b39f8.png";